import './audit-campaign-featured-card.scss'

import { defineComponent } from 'vue'

import { AuditRoutes } from '@skinsoft/const'
import { reactiveVueMixin } from '@skinsoft/reactive-vue'
import { Touchable } from '@skinsoft/ui'

export const AuditCampaignFeaturedCard = defineComponent({
    mixins: [reactiveVueMixin],
    components: {
        sTouchable: Touchable
    },
    props: ['campaignFeatured', 'clickAction'],
    template: require('./audit-campaign-featured-card.html'),
    data() {
        return {
            ready: false,
        }
    },
    methods: {
        openCampaign() {
            this.$router.push({ name: AuditRoutes.CAMPAIGN, params: { campaignId: this.campaignFeatured.id } });
        },

        performClick() {
            switch(this.clickAction) {
                case 'addToCampaign':
                    this.$emit('addToCampaign', this.campaignFeatured.id)
                    break
                default:
                    this.openCampaign()
            }
        },
    },
    watch: {
        campaignFeatured: {
            handler() {
                this.ready = !!this.campaignFeatured;
            },
            immediate: true,
        },
    },
})
